import firebase from 'firebase';

export const initializeFirebase = () => {
  if (isIosWebView()) {
    console.log("iOS WebView wykryty – pomijam inicjalizację FCM");
    return;
  }

  const firebaseConfig = {
    apiKey: "",
    authDomain: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: ""
  };

  firebase.initializeApp(firebaseConfig);

  // use other service worker
  // navigator.serviceWorker
  //   .register('/my-sw.js')
  //   .then((registration) => {
  //     firebase.messaging().useServiceWorker(registration);
  //   });
}

function isIosWebView() {
  const ua = navigator.userAgent;
  return (
    /iPhone|iPad|iPod/i.test(ua)
  );
}

export const askForPermissionToReceiveNotifications = async () => {

  try {
    if (isIosWebView()) {
      const tokenIOS =  window.localStorage.getItem('token') ?? '';
      if (tokenIOS !== '') {
        return {
          status: "SUCCESS",
          token: tokenIOS
        };
      } else {
        return ({
          status: "FAIL",
          error: 'Notification permission denied'
        });
      }
    } else {
      const messaging = firebase.messaging();
      // await messaging.requestPermission();
      let permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await messaging.getToken({vapidKey: "BOAYEk9-g10hFVA3DrjIFx2b_EZ_Nmzo2cCbZhqfFGM96JY2Dv7g3UG3T8GOrz6apoVEbSnBBurFeyz1gL5fxwY"});
        return ({
          status: "SUCCESS",
          token: token
        });
      } else {
        return ({
          status: "FAIL",
          error: 'Notification permission denied'
        });
      }
    }
  } catch (error) {
    return ({
      status: "FAIL",
      error: error
    });
  }
}
